import { render, staticRenderFns } from "./domainMapping.vue?vue&type=template&id=4ead8d84"
import script from "./domainMapping.vue?vue&type=script&lang=js"
export * from "./domainMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports